import React, { useEffect, useState } from 'react'
import "./styles.css";
import { ReactComponent as Showpassword } from "common/assets/svg/showPassword.svg";
import { ReactComponent as Hidepassword } from "common/assets/svg/hidePassword.svg";
import DialCodePicker, { CountryCodeData } from 'components/dialCodePicker';
import {  SignUpForm } from 'common/features/auth/AuthModels';
import { useForm } from 'react-hook-form';
import { useDispatch,useSelector } from 'react-redux';
import { validateField } from 'common/utils/field-validator';
import { RootState } from 'common/rootReducer';
import { verifyMobile } from 'common/features/auth/AuthActions';
import PasswordError from 'components/PasswordError';
export interface AuthRegisterInterface {
    handleOnPageSwitch:(key:string)=>void;
    handleOnSuccess:(key:string,data:any)=>void;
  }


const AuthRegister = (props:AuthRegisterInterface) => {

    const dispatch = useDispatch();

    const {handleOnPageSwitch,handleOnSuccess} = props;

    const [showDialCodePicker, setShowDialCodePicker] = useState(false);
    const [countryData, setCountryData] = useState<CountryCodeData>({
        code: "+1",
        flag: "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg",
      });
    const [userId, setUserId] = useState("");
    const [isPasswordShown, setIsPasswordShown] = useState(false);
    const [isConfirmPasswordShown, setIsConfirmPasswordShown] = useState(false);

    const [formErrorMessage, setFormErrorMessage] = useState<string | null>(null);
    const [amceConsent, setAMCEConsent] = useState( true  );
    const [showAmceConsentError, setShowAMCEConsentError] = useState(false);
    const [payloadData, setPayloadData] = useState<any>(null);
    const restaurantDetails = useSelector(
        (state: RootState) => state.restaurant.currentRestaurantDetail
    ); 

    const authState = useSelector((state: RootState) => state.auth);


    const {register,errors,handleSubmit,control,getValues,setValue,watch, formState,} = useForm<SignUpForm>({
        defaultValues: {
            fullName: "",
            email: "",
            mobilePhone: "",
            password: "",
            confirmPassword: "",
        },
      });

    useEffect(() => {        
        if (!authState.mobileVerficationLoading && !authState.mobileVerifiedSuccess && formState.isSubmitted && authState.otpRequired ) {
            handleOnSuccess('REGISTER_OTP',payloadData)
        }
        // Invalid
        if (!authState.mobileVerficationLoading && !authState.mobileVerifiedSuccess &&  formState.isSubmitted && !authState.otpRequired) {
          setFormErrorMessage(authState.mobileVerficationMessage);
        }
    }, [authState.mobileVerficationLoading]);

    const onSubmit = (data: SignUpForm) => {
        const payload = {
            fullName: data.fullName,
            mobilePhone: countryData.code + "-" + data.mobilePhone,
            password: data.password,
            email: data.email,
            sendOtp: 1,
            isReceiveTransMsg:amceConsent?1:0,
            isRegisterUser:true,
          };
        setPayloadData(payload);
        dispatch(verifyMobile(payload));
      };

  return (
    <React.Fragment>
        <div id="sign-in-screen">
      
            <form id="sign-in-form" onSubmit={handleSubmit(onSubmit)}>

                <div id="text-box-container-ad" style={{ marginTop: "1rem" }}>
                    <label id="input-label">Name</label>
                    <div id="signIn-text-box" style={{ marginTop: "0.5rem" }}>
                    <input
                        className="pwd"
                        type="text"
                        name="fullName"
                        placeholder="Enter Name"
                        ref={register(
                        validateField("fullName").isRequired().isValidName().Rules
                        )}
                    />
                    </div>

                    <span id="error-msg">
                        {errors.fullName && errors.fullName.type === "required" && (
                            <span className="req-msg">Name Required</span>
                        )}
                        {errors.fullName && errors.fullName.type === "minLength" && (
                            <span className="req-msg">Enter a Valid Name</span>
                        )}
                        {errors.fullName && errors.fullName.type === "pattern" && (
                            <span className="req-msg">Enter a Valid Name</span>
                        )}
                    </span>
                </div>

                <div id="text-box-container-ad" style={{ marginTop: "1rem" }}>
                    <label id="input-label">User ID</label>
                    <div id="signIn-text-box" style={{ marginTop: "0.5rem" }}>
                        <React.Fragment>
                        <img
                            alt="flag"
                            src={countryData.flag}
                            height={"14px"}
                            width={"21px"}
                            className="flag"
                            onClick={() => setShowDialCodePicker(!showDialCodePicker)}
                        />
                        &nbsp;
                        <span id="countryCode" onClick={() => setShowDialCodePicker(!showDialCodePicker)} >
                            {countryData.code}
                        </span>
                        </React.Fragment>
                        <input
                            type="text"
                            placeholder="Enter Mobile number"
                            name="mobilePhone"
                            ref={register(validateField("mobilePhone").isValidMobileNumber().isRequired().Rules)}
                            // onChange={(event) => {
                            // const validatedValue = event.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                            // setUserId(validatedValue);                        
                            // }}
                            //value={userId}
                            maxLength={10}
                            autoComplete="off"
                            className="mobile-detail"
                        />
                    </div>
                    <span id="error-msg">
                        {errors.mobilePhone && errors.mobilePhone.type === "required" && (
                            <span className="req-msg">Mobile is Required</span>
                        )}
                        {errors.mobilePhone && errors.mobilePhone.type === "pattern" && (
                            <span className="req-msg">Enter a Valid Mobile Number</span>
                        )}
                    </span>
                    <DialCodePicker
                        showPicker={showDialCodePicker}
                        setShowPicker={setShowDialCodePicker}
                        setCountryData={setCountryData}
                        inputValue={userId}
                        setIsMobile={()=>{}}
                        onlyMobile={false}
                    />
                </div>

                <div id="text-box-container-ad" style={{ marginTop: "1rem" }}>
                    <label className="input-label">Email</label>
                    <div id="signIn-text-box">
                    <input
                        className="pwd"
                        type="text"
                        name="email"
                        placeholder="Enter Email"
                        ref={register(
                        validateField("email").isRequired().isValidEmail().Rules
                        )}
                    />
                    </div>
                    <span id="error-msg">
                    {errors.email && errors.email.type === "required" && (
                        <span className="req-msg">Email Required</span>
                    )}
                    {errors.email && errors.email.type === "minLength" && (
                        <span className="req-msg">Enter a Valid Email</span>
                    )}
                    {errors.email && errors.email.type === "pattern" && (
                        <span className="req-msg">Enter a Valid Email</span>
                    )}
                    </span>
                </div>

                <div id="text-box-container-ad" style={{ marginTop: "1rem" }}>
                    <label className="input-label">Password</label>
                    <div id="signIn-text-box">
                        <input
                            style={{ fontSize: 13 }}
                            className="pwd"
                            type={isPasswordShown ? "text" : "password"}
                            name="password"
                            placeholder="Enter password"
                            autoComplete="off"
                            ref={register({
                                required: "Password is required",
                                minLength: {
                                  value: 8,
                                  message: "Password must be more than 8 characters long",
                                },
                                pattern: {
                                  value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[^\s]{8,}$/,
                                  message: "Password must be alphanumeric, contain at least one uppercase letter, one special character and must not have spaces",
                                },
                              })}
                            //ref={register(validateField("password").isValidPassword().isRequired().Rules)}
                        />
                        {isPasswordShown ? (
                            <Hidepassword
                                className="hidePasswordSVG"
                                onClick={() => {
                                    setIsPasswordShown(!isPasswordShown);
                                }}
                            />
                        ) : (
                            <Showpassword
                                className="showPasswordSVG"
                                onClick={() => {
                                    setIsPasswordShown(!isPasswordShown);
                                }}
                            />
                        )}

                    </div>
                    <span id="error-msg">
                        {errors.password && errors.password.type === "required" && (
                            <span className="req-msg">Password Required</span>
                        )}
                         {errors.password && errors.password.type === "minLength" && (
                            <span className="req-msg">{errors.password.message}</span>
                        )}
                          {errors.password && errors.password.type === "pattern" && (
                            <PasswordError/>
                        )}
                    </span>
                </div>

                <div id="text-box-container-ad" style={{ marginTop: "1rem" }}>
                    <label className="input-label">Confirm Password</label>
                    <div id="signIn-text-box">
                        <input
                            style={{ fontSize: 13 }}
                            className="pwd"
                            type={isConfirmPasswordShown ? "text" : "password"}
                            name="confirmPassword"
                            placeholder="Re-enter password"
                            autoComplete="off"
                            ref={register(validateField("confirmPassword")
                            .isRequired()
                            .matchesField(
                              watch,
                              "password",
                              "",
                              "Password does not match"
                            ).Rules)}
                        />
                        {isConfirmPasswordShown ? (
                        <Hidepassword
                        className="hidePasswordSVG"
                        onClick={() => {
                            setIsConfirmPasswordShown(!isConfirmPasswordShown);
                        }}
                        />
                        ) : (
                        <Showpassword
                        className="showPasswordSVG"
                        onClick={() => {
                            setIsConfirmPasswordShown(!isConfirmPasswordShown);
                        }}
                        />
                        )}

                    </div>
                    <span id="error-msg">
                    {errors.confirmPassword &&
                        errors.confirmPassword.type == "required" && (
                        <span className="req-msg">Password Required</span>
                        )}
                    {errors.confirmPassword &&
                        errors.confirmPassword.type == "validate" && (
                        <span className="req-msg">{errors.confirmPassword.message}</span>
                        )}
                    </span>
                </div>

                <div id="links-container">
                    <div>
                        <div className="consent-msg-container">
                            {/* <input
                                type="checkbox"
                                className="consent-msg-checkbox"
                                checked={amceConsent}
                                onChange={(e) => {
                                setAMCEConsent(!amceConsent);
                                setShowAMCEConsentError(amceConsent ? false :true)
                                }}
                            /> */}
                            <span className="consent-msg-text">
                            By proceeding further, you agree to our Privacy Policy and Terms & Conditions. You also consent to receive text messages and emails for your account activity. Standard text messaging rates may apply.
                              {/* By providing your phone number, you agree to receive text message from{" "}
                              {restaurantDetails.branchName} */}
                            </span>
                        </div>

                        {!amceConsent && showAmceConsentError && (
                        <p className="consent-error-msg">Check this to receive text message</p>
                        )}
                    </div>

                    <span className="sign-up-form-error-msg desktop-login-form-error-msg"  style={{ marginBottom: "15px", width: "305px" }} > {formErrorMessage ? formErrorMessage : null} </span>
                    <button id={!amceConsent?"sign-in-button-ad-disable" :  "sign-in-button-ad"} disabled={authState.signInLoading || !amceConsent}  type="submit"  style={{ width: 305 }}> 
                        {authState.mobileVerficationLoading  ? "Verifying Mobile"  : "Create"}
                    </button>

                    <div id="register-link">
                        <span>Already have an account?</span>
                        &nbsp;
                        <span id="create-new-account"  onClick={() => {handleOnPageSwitch('LOGIN')}}>Login</span>
                    </div>

                </div>
            </form>
        </div>
    </React.Fragment>
  )
}

export default AuthRegister